import api from "../../services/api";
import { types } from "../types/types";
import Constants from "../../services/constant";
import { showToast } from "./toastAction";

const getNetworkGasFeeList = (setLoading) => async (dispatch) => {
    if (setLoading) setLoading(true);
    const res = await api("get", Constants.END_POINT.NETWORK_GAS_FEES);
    if (res.success) {
        dispatch({
            type: types.NETWORK_GAS_FEES,
            payload: res.data || [],
        });
    } else {
        dispatch({
            type: types.NETWORK_GAS_FEES,
            payload: [],
        });
    }
    if (setLoading) setLoading(false);
};

const createNetworkGasFee = (data, setLoading) => async (dispatch) => {
    setLoading(true);
    const res = await api("post", Constants.END_POINT.NETWORK_GAS_FEES, data);
    if (res.success) {
        dispatch(showToast({ severity: "success", summary: res.message }));
        dispatch(getNetworkGasFeeList(setLoading));
    } else {
        dispatch(showToast({ severity: "error", summary: res.message || "Failed to create network" }));
        if (setLoading) setLoading(false);
    }
};

const updateNetworkGasFee = (id, data, setLoading) => async (dispatch) => {
    setLoading(true);
    const res = await api("put", Constants.END_POINT.UPDATE_NETWORK_GAS_FEE + id, data);
    if (res.success) {
        dispatch(showToast({ severity: "success", summary: res.message }));
        dispatch(getNetworkGasFeeList(setLoading));
    } else {
        dispatch(showToast({ severity: "error", summary: res.message || "Failed to update network" }));
        if (setLoading) setLoading(false);
    }
};

const toggleNetworkGasFee = (id, setLoading) => async (dispatch) => {
    setLoading(true);
    const res = await api("put", Constants.END_POINT.TOGGLE_NETWORK_GAS_FEE + id);
    if (res.success) {
        dispatch(showToast({ severity: "success", summary: res.message }));
        dispatch(getNetworkGasFeeList(setLoading));
    } else {
        dispatch(showToast({ severity: "error", summary: res.message || "Failed to toggle network" }));
        if (setLoading) setLoading(false);
    }
};

const deleteNetworkGasFee = (id, setLoading) => async (dispatch) => {
    setLoading(true);
    const res = await api("delete", Constants.END_POINT.NETWORK_GAS_FEES + "/" + id);
    if (res.success) {
        dispatch(showToast({ severity: "success", summary: res.message }));
        dispatch(getNetworkGasFeeList(setLoading));
    } else {
        dispatch(showToast({ severity: "error", summary: res.message || "Failed to delete network" }));
        if (setLoading) setLoading(false);
    }
};

export {
    getNetworkGasFeeList,
    createNetworkGasFee,
    updateNetworkGasFee,
    toggleNetworkGasFee,
    deleteNetworkGasFee,
};
